export const generateUniqueId = (userID) => {
  const timestamp = Date.now();
  const uniqueId = `ss_${userID}_${timestamp}`;
  return uniqueId;
};

/**
 * Function to handle clicking on an image.
 * @param {Event} event - The click event.
 * @param {Object} _ - Placeholder for lodash functions.
 * @param {Function} setOpenImage - Function to set the visibility of the image popup.
 * @param {Function} setImg - Function to set the image source.
 * @param {boolean} openImage - Current state of the image popup.
 * @returns {void}
 * @author Shivam
 */
export const handleImageClick = (event, _, setOpenImage, setImg, openImage) => {
  const { target } = event;
  const posAtCoords = _.posAtCoords({
    left: event.pageX,
    top: event.pageY,
  });

  if ((posAtCoords && _.nodeDOM(posAtCoords?.pos)?.tagName === "IMG") || target.nodeName === "IMG") {
    const imgSrc = _.nodeDOM(posAtCoords?.pos)?.src || target.src;
    if (imgSrc) {
      setImg(imgSrc);
      setOpenImage(!openImage);
    }
  }
};

/**
 * Generates a random hex color code.
 * Ensures the code is always in the proper 6-character format (e.g., #RRGGBB).
 * @returns {string} A valid hex color string.
 */
export const generateRandomHexColor = () => {
  // Generate a random integer between 0 and 0xFFFFFF (16,777,215 in decimal)
  const randomInt = Math.floor(Math.random() * 0xffffff);
  // Convert to a hex string and pad to ensure it's always 6 characters long
  const hexColor = randomInt.toString(16).padStart(6, "0");
  // Return the color with a leading '#'
  return `#${hexColor}`;
};

export const formatUserTimestamp = (username, date) => {
  const now = new Date(date);
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  // const seconds = String(now.getSeconds()).padStart(2, "0");
  return `${username} (${day}/${month} ${hours}:${minutes})`;
};
